module.exports = __webpack_public_path__ + "static/media/carbon-insurance.00eda1b4.png";